import type { Group } from "@/group";
import { showSnackbar } from "@/snackbar/snackbar";
import { SNACKBAR_TIMEOUT } from "../constants/aiConstants";
import { checkIsWidgetsQuantityExceeded } from "./checkIsWidgetsQuantityExceeded";

export function checkWidgetsForAi(widgets: Group[]) {
    const isWidgetsQuantityExceeded = checkIsWidgetsQuantityExceeded(widgets);

    if (isWidgetsQuantityExceeded) {
        showSnackbar("Можно выбрать не более 70 элементов", { duration: SNACKBAR_TIMEOUT });
    }

    return isWidgetsQuantityExceeded;
}
